import { TRootState } from "../@types"

export const selectModalIpAccessRules = (state: TRootState) =>
  state.ipAccessRules.ipAccessRulesModalIsOpen

export const selectIsUpdateIpAccessRules = (state: TRootState) =>
  state.ipAccessRules.isUpdateIpAccessRules

export const selectIpAccessRulesForUpdate = (state: TRootState) =>
  state.ipAccessRules.ipAccessRulesForUpdate

export const selectIpAccessRulesRefreshTable = (state: TRootState) =>
  state.ipAccessRules.refreshTableIpAccessRules
